const FEDERATE_PROD_URL = 'idp.federate.amazon.com'
const FEDERATE_ALPHA_URL = 'idp-integ.federate.amazon.com'
const FEDERATE_BETA_URL = 'idp-integ.federate.amazon.com'

const FEDERATE_ALPHA_CLIENT_ID = 'fcbookmarks-alpha'
const FEDERATE_BETA_CLIENT_ID = 'fcbookmark-test' // no s https://integ.ep.federate.a2z.com/profile/fcbookmark-test
// const FEDERATE_BETA_CLIENT_ID = 'fcbookmarks-beta'
// const FEDERATE_PROD_CLIENT_ID = 'fcbookmarks-prod'
const FEDERATE_PROD_CLIENT_ID = 'fcbookmarks-moc'

export enum FederateStage {
  ALPHA = 'ALPHA',
  BETA = 'BETA',
  PROD = 'PROD'
}

const getFederateHost = (stage: string) => {
    switch (stage) {
        case FederateStage.BETA:
            return FEDERATE_BETA_URL
        case FederateStage.PROD:
            return FEDERATE_PROD_URL
        default:
            return FEDERATE_ALPHA_URL
    }
}

const getFederateClientId = (stage: string) => {
    switch (stage) {
        case FederateStage.BETA:
            return FEDERATE_BETA_CLIENT_ID
        case FederateStage.PROD:
            return FEDERATE_PROD_CLIENT_ID
        default:
            return FEDERATE_ALPHA_CLIENT_ID
    }
}

export const getFederateConfig = (stage: string) => {
    return {
        idPAuthorizeEndpoint: `https://${getFederateHost(stage)}`,
        clientId: getFederateClientId(stage),
    }
}